import React, {useContext, useEffect, useState} from 'react';
import {FormOperacionControlOperativoDetalle, schemaFormOperacionControlOperativoDetalle} from "../types/types";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import ControlOperativoDetalle from "./ControlOperativoDetalle";
import {HttpControlOperativo} from "../api/httpControlOperativo";
import toast from "react-hot-toast";
import {OperacionControlOperativoDetalleFields} from "../types/fields";
import ControlOperativoDetalleForm from "./ControlOperativoDetalleForm";
import {ContextOperacion, ContextOperacionType} from "../../../RefactorLayout";
import {QueryStatus} from "../../../../../types";
import CircularProgress from "@mui/material/CircularProgress";
import {useDetalle} from "../hooks/useDetalle";

interface SeccionControlOperativoDetalleProps {
  codPais: number,
  operacionId: number,
}

function SeccionControlOperativoDetalle({codPais, operacionId}: SeccionControlOperativoDetalleProps) {
  const {permisoTipo} = useContext<ContextOperacionType>(ContextOperacion)

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const {detalle, status, refetch} = useDetalle(operacionId);

  const formMethods = useForm<FormOperacionControlOperativoDetalle>({
    resolver: zodResolver(schemaFormOperacionControlOperativoDetalle),
  });

  useEffect(() => {
    if (detalle) {
      formMethods.reset({...detalle});
    }
  }, [detalle, formMethods]);

  const alGuardarDetalle = (data: FormOperacionControlOperativoDetalle) => {
    const promise = HttpControlOperativo.putDetalle(operacionId, data.id, data);

    toast
      .promise(promise, {
        loading: 'Guardando',
        success: 'Guardado correctamente',
        error: 'Error al guardar'
      })
      .then(() => {
        refetch();
        setOpenDialog(false);
      });
  };

  return (

    <>
      {
        status === QueryStatus.Loading
          ? <CircularProgress disableShrink sx={{mt: 6}}/>
          : (detalle?.[OperacionControlOperativoDetalleFields.PermiteEditar] && permisoTipo > 1) ?
            <ControlOperativoDetalleForm codPais={codPais} formMethods={formMethods} onSubmitForm={alGuardarDetalle}
                                         detalle={detalle}/>
            : <ControlOperativoDetalle detalle={detalle}/>

      }
    </>
  );
}

export default SeccionControlOperativoDetalle;